// extracted by mini-css-extract-plugin
export default {"InfoUtilisateur":"MenuUtilisateur_InfoUtilisateur__QVih6","BoutonsLegaux":"MenuUtilisateur_BoutonsLegaux__-gED5","Menu":"MenuUtilisateur_Menu__EQ6xl"};